"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./colorByName"), exports);
tslib_1.__exportStar(require("./outside-click"), exports);
//# sourceMappingURL=index.js.map